module.exports = "<div class=\"kan-spinner-container\">\n    <mat-spinner color=\"primary\"></mat-spinner>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/services/components/loading/component.html
// module id = ./src/modules/services/components/loading/component.html
// module chunks = main